import React, { useState, useImperativeHandle, forwardRef, useRef } from "react";
import { Text } from "@fluentui/react";
import MultiAutocomplete, { MultiAutocompleteRef } from "../../baseComponents/MultiAutocomplete";

interface ISLSearchFiscalPeriodsProps {}

export interface ISLSearchFiscalPeriodsRef {
  getFiscalPeriods: () => number[];
  setInitialFiscalPeriods: (initialFiscalPeriods: number[]) => void;
  reset: () => void;
}

const SLSearchFiscalPeriods = forwardRef((props: ISLSearchFiscalPeriodsProps, ref) => {
  // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
  const [_fiscalPeriods] = useState<string[]>(Array.from({ length: 12 }, (r, i) => `${i + 1}`));
  const autocompleteRef = useRef<MultiAutocompleteRef>(null);

  useImperativeHandle(
    ref,
    (): ISLSearchFiscalPeriodsRef => ({
      getFiscalPeriods() {
        if (autocompleteRef.current) {
          return autocompleteRef.current
            .getSelectedItems()
            .map((x) => Number(x))
            .filter((x) => !isNaN(x));
        }
        return [];
      },
      setInitialFiscalPeriods(initialFiscalPeriods) {
        if (autocompleteRef.current) {
          autocompleteRef.current.setInitialSelectedItems(initialFiscalPeriods.map(String));
        }
      },
      reset() {
        if (autocompleteRef.current) {
          autocompleteRef.current.reset();
        }
      }
    })
  );

  return (
    <React.Fragment>
      <MultiAutocomplete
        label="Fiscal Period"
        required={false}
        items={_fiscalPeriods}
        ref={autocompleteRef}
        transformSelection={(item) => {
          return (item as string).substring(0, 4);
        }}
      />
      <Text
        nowrap
        variant="xSmall"
        block
        style={{
          marginTop: "4px",
          color: "var(--accent-font-color, gray)"
        }}
      >
        Multiple fiscal periods enabled. Separate by semicolons.
      </Text>
    </React.Fragment>
  );
});

SLSearchFiscalPeriods.displayName = "SLSearchFiscalPeriods";

export default SLSearchFiscalPeriods;
